import { render, staticRenderFns } from "./alertDialog.vue?vue&type=template&id=6201ce1e&scoped=true"
import script from "./alertDialog.vue?vue&type=script&lang=js"
export * from "./alertDialog.vue?vue&type=script&lang=js"
import style0 from "./alertDialog.vue?vue&type=style&index=0&id=6201ce1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6201ce1e",
  null
  
)

export default component.exports